import React, { useState, useEffect } from 'react';

const AuctionTimer = ({ endTime }) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0, ended: false });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const end = new Date(endTime);
      const now = new Date();
      const diff = end - now;

      if (diff <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0, ended: true });
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds, ended: false });
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(interval);
  }, [endTime]);

  if (timeLeft.ended) {
    return (
      <div className="glass p-6 rounded-sm text-center" data-testid="auction-timer-ended">
        <div className="text-2xl font-heading font-bold text-red-500">AUCTION ENDED</div>
      </div>
    );
  }

  return (
    <div className="glass p-6 rounded-sm" data-testid="auction-timer">
      <div className="text-center mb-4">
        <div className="text-sm text-textSecondary uppercase tracking-wider">Time Remaining</div>
      </div>
      <div className="grid grid-cols-4 gap-4">
        {[{label: 'Days', value: timeLeft.days}, {label: 'Hours', value: timeLeft.hours}, {label: 'Minutes', value: timeLeft.minutes}, {label: 'Seconds', value: timeLeft.seconds}].map((item, idx) => (
          <div key={idx} className="text-center">
            <div className="bg-surfaceHighlight rounded-sm p-3">
              <div className="text-3xl font-mono font-bold text-primary">
                {String(item.value).padStart(2, '0')}
              </div>
            </div>
            <div className="text-xs text-textSecondary mt-2 uppercase">{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AuctionTimer;